/** 站点域名默认值（接口加载前 / 失败时回退） */
export const defaultSiteConfig = {
  www: 'https://www.mazhizuo.com',
  admin: 'https://qr.mazhizuo.com',
  api: '/api',
  qr: 'https://qr.mazhizuo.com',
  doc: 'https://doc.mazhizuo.com',
  vip: 'https://qr.mazhizuo.com/vip.php',
  terms: 'https://www.mazhizuo.com/terms',
  privacy: 'https://www.mazhizuo.com/privacy-policy-2',
  gzhImage: 'https://www.mazhizuo.com/static/images/gzh.jpg',
  qrAccessBase: 'https://qr.mazhizuo.com/v?url=',
  /** 旧站 img.php 文本_解密数据 密钥（由 /api/site/public.php 下发；缺省与旧站一致） */
  legacyImgCipherKey: 'ZengJeson2022',
  /** 扫码泛域名防封（由 /api/site/public.php 下发） */
  qrWildcard: {
    enabled: false,
    domain: '',
    scheme: 'https',
    prefixLength: 4
  },
  /** 免费用户每月每码访问上限（由 /api/site/public.php / pay/plans 下发） */
  freeMonthlyVisitLimit: 100,
  freeMonthlyVisitLimitEnabled: true,
  freeMonthlyVisitLimitLabel: '100次/码',
  freeMonthlyVisitResetDate: ''
}

const PREFIX_ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789'

let cached = null

export function setSiteConfig(cfg) {
  const next = Object.assign({}, defaultSiteConfig, cfg || {})
  if (cfg && cfg.qrWildcard && typeof cfg.qrWildcard === 'object') {
    next.qrWildcard = Object.assign({}, defaultSiteConfig.qrWildcard, cfg.qrWildcard)
  }
  cached = next
  return cached
}

export function getSiteConfig() {
  return cached || defaultSiteConfig
}

/** @param {keyof typeof defaultSiteConfig} key */
export function siteUrl(key) {
  const cfg = getSiteConfig()
  return cfg[key] || defaultSiteConfig[key] || ''
}

export function qrAccessUrl(uid) {
  const base = siteUrl('qrAccessBase') || defaultSiteConfig.qrAccessBase
  return `${base}${uid || ''}`
}

function randomWildcardPrefix(length) {
  const len = Math.max(2, Math.min(16, Number(length) || 4))
  let out = ''
  const n = PREFIX_ALPHABET.length
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const buf = new Uint8Array(len)
    crypto.getRandomValues(buf)
    for (let i = 0; i < len; i++) {
      out += PREFIX_ALPHABET[buf[i] % n]
    }
    return out
  }
  for (let i = 0; i < len; i++) {
    out += PREFIX_ALPHABET[Math.floor(Math.random() * n)]
  }
  return out
}

/**
 * 当前是否已在泛域目标主机（*.domain）
 * @param {{ enabled?: boolean, domain?: string }} [wc]
 */
export function isQrWildcardTargetHost(wc) {
  const cfg = wc || (getSiteConfig().qrWildcard || {})
  if (!cfg.enabled || !cfg.domain) return false
  const host = String((typeof location !== 'undefined' && location.hostname) || '').toLowerCase()
  const domain = String(cfg.domain).toLowerCase().replace(/^\*\./, '')
  if (!host || !domain) return false
  return host === domain || host.endsWith('.' + domain)
}

/**
 * 非泛域主机访问 /v 时，跳到随机子域（与服务端 qr.php 行为一致）
 * @param {string} uid
 * @returns {boolean} 是否已发起跳转
 */
export function jumpToQrWildcardIfNeeded(uid) {
  const cfg = (getSiteConfig() && getSiteConfig().qrWildcard) || {}
  if (!cfg.enabled || !cfg.domain) return false
  if (isQrWildcardTargetHost(cfg)) return false
  const id = String(uid || '').trim()
  if (!id) return false
  const prefix = randomWildcardPrefix(cfg.prefixLength)
  const scheme = cfg.scheme === 'http' || cfg.scheme === 'https'
    ? cfg.scheme
    : (typeof location !== 'undefined' && location.protocol === 'http:' ? 'http' : 'https')
  const target = `${scheme}://${prefix}.${cfg.domain}/v?url=${encodeURIComponent(id)}`
  if (typeof location !== 'undefined') {
    location.replace(target)
  }
  return true
}
